module.exports = __webpack_public_path__ + "img/bling.f1e44d6a.png";